import OrderReminderReducerData from "@TKCCP/Store/CustomHandlerCreator/OrderReminderReducerData";
import SubscriptionProductReducerData from "@TKCCP/Store/CustomHandlerCreator/SubscriptionProductReducerData";
import { combineReducers } from "redux";

const customDataReducerData = {
    orderRiminderDataStore: OrderReminderReducerData,
    SubscriptionProductStore: SubscriptionProductReducerData

};

export type DataReducers = typeof customDataReducerData;

const customDataReducer = combineReducers(customDataReducerData as any);

export default customDataReducer;
